module.exports = __webpack_public_path__ + "../resources/img/@temp_chart_pie.edd14000.jpg";